<template>
	<router-view :class="appClasses" />
</template>

<script>
export default {
	name: "Dailycore",
	computed: {
		appClasses() {
			return this.$store.getters.appclasses;
		}
	}
};
</script>

<style lang="scss">
// @import "~vue-wysiwyg/dist/vueWysiwyg.css";
// @import '~animate.css';
// .animated {
//   animation-duration: .377s;
// }
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome";
</style>
